export default __webpack_public_path__ + "static/media/adaptive_superwarm.1c06acc1.jpg";